import { globalTokens, rgba } from '@domain-group/fe-brary';
import { ghostButtonStyles } from '../utils';
export default ghostButtonStyles({
  base: {
    default: globalTokens.colors.white,
    hover: globalTokens.colors.white
  },
  surface: {
    hover: rgba(globalTokens.colors.white, 0.2),
    pressed: rgba(globalTokens.colors.white, 0.3)
  },
  trim: {
    default: globalTokens.colors.white,
    hover: globalTokens.colors.white,
    pressed: globalTokens.colors.white
  }
}, {
  trim: {
    disabled: rgba(globalTokens.colors.white, 0.4)
  },
  base: {
    disabled: rgba(globalTokens.colors.white, 0.6)
  }
});